export default __webpack_public_path__ + "static/media/image.0cd99f98.png";